import React, { useState } from "react";
import api from "../../api";
import styles from './style.module.css'

const RegistrationLite = () => {
    const [fio, setFio] = useState('');
    const [qrCode, setQrCode] = useState(null);
    const [documentLink, setDocumentLink] = useState(null);
    const [error, setError] = useState('');

    const handleFioChange = (event) => {
        setFio(event.target.value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        api.registrationConferenceLite({ fio })
            .then((data) => {
                setQrCode(data.qr_code);
                const link = data.document.replace("/app", '');
                setDocumentLink(link);
                window.open(`http://158.160.65.66${link}`, '_blank');
                setFio('')
                setError('');
            })
            .catch((err) => {
                setError('Ошибка регистрации: ' + err.message);
            });
    };

    return (
        <div className={styles.reg_lite__area}>
            <form onSubmit={handleSubmit} className={styles.reg_lite__form}>
                <input
                    type="text"
                    value={fio}
                    onChange={handleFioChange}
                    placeholder="Введите ФИО"
                    required
                />
                <button type="submit">Создать</button>
            </form>
            {error && <p style={{ color: 'red' }}>{error}</p>}

        </div>
    );
}

export default RegistrationLite;